<div class="flex  fg-1 " *ngIf="leaveFlag == true && !is_MD_LT">
  <div style="flex-grow:0.7;"></div>
  <app-header-search></app-header-search>
  <div style="flex-grow:0.3;"></div>
</div>
<div #refHeaderSearchMobile class="user-search-mobile flex center-xs"
  *ngIf="(leaveFlag && is_MD_LT && isUserSearchMobileOpen)">
  <app-header-search (userSelected)="isUserSearchMobileOpen = false;" [stopOptionClickPropagation]="true"
    (click)="onClickUserSearchMobile($event)" class="mt-10"></app-header-search>
  <svg class="use-svg col-primary-200 user-search-mobile__close" (click)="isUserSearchMobileOpen = false;"
    symbol="circle-close-red" w="25"></svg>
</div>
<div class="common-grid"
  [ngClass]="{'l0-grid': (role_id == 1 || role_id == 2) && leaveFlag, 'l2-l3-grid' : (role_id == 3 || (role_id == 4 && !this.is_admin)) && leaveFlag, 'hr-grid': this.is_admin && leaveFlag }">

  <div #refOpenUserSearchMobile class="user-search-open" (click)="isUserSearchMobileOpen = true;">
    <svg symbol="user-search" w="22" class="use-svg  col-primary-200"></svg>
  </div>
  <div class="compliances " *ngIf="leaveFlag == true">
    <div class="compliances__item " [ngClass]="{'mr-1':i != 4,'mr-sm-5':i != 4, 'mr-md-10': i !!= 4, 'mr-xmd-15':i != 4}"
      *ngFor="let com of compliances; let i=index;">
      <svg [attr.width]="is_MD_LT ? 22 : 26" [attr.height]="is_MD_LT ? 22 : 26">
        <defs>
          <linearGradient id="red-compliance" gradientTransform="rotate(45)">
            <stop offset="0%" [attr.stop-color]="'var(--col-warn-500)'" />
            <stop offset="100%" [attr.stop-color]="'var(--col-warn-A400)'" />
          </linearGradient>
          <linearGradient id="green-compliance" gradientTransform="rotate(45)">
            <stop offset="0%" [attr.stop-color]="'var(--col-accent-400)'" />
            <stop offset="100%" [attr.stop-color]="'var(--col-accent-A400)'" />
          </linearGradient>
        </defs>
        <circle *ngIf="com.cnt==0 && com.valid" [attr.r]="is_MD_LT ? 9 : 11" [attr.cx]="is_MD_LT ? 11 : 13"
          [attr.cy]="is_MD_LT ? 11 : 13" fill="none" stroke="url('#green-compliance')"
          [attr.stroke-width]="is_MD_LT ? 2 : 3">
        </circle>
        <circle *ngIf="com.cnt==1 && com.valid" [attr.r]="is_MD_LT ? 9 : 11" [attr.cx]="is_MD_LT ? 11 : 13"
          [attr.cy]="is_MD_LT ? 11 : 13" fill="none" stroke="url('#red-compliance')"
          [attr.stroke-width]="is_MD_LT ? 2 : 3"></circle>
      </svg>
      <span *ngIf="com.valid">{{com.week}}</span>
    </div>
  </div>

  <div *ngIf="showEmailToggle && leaveFlag == true"
    class="flex col p-5 center-xs middle-xs ml-sm-15 mr-sm-15">
    <span class="fs-12 fs-md-13">Emails</span>
    <mat-slide-toggle [class.small]="is_MD_LT" (change)="onEmailToggle($event)" [(ngModel)]="isEmailEnabled">
    </mat-slide-toggle>
  </div>

  <app-button style="max-width: 120px;justify-self: end;" class="logout" theme="red" (click)="logout()">
    Logout
  </app-button>

  <div class="logout-icon" (click)="logout()">
    <svg class="use-svg col-warn-500" symbol="logout" w="22"> </svg>
  </div>

</div>
